import type { SceneGraph, SceneStore } from '@os/doc';

/**
 * The scene graph for a render. `dep` (a subscribed snapshot: the object list, the edited object) is only there so the
 * React Compiler recomputes the call when the scene changes: a call that depends on `store` alone is cached for good.
 */
export function graphOf(store: SceneStore, dep: unknown): SceneGraph {
  void dep;
  return store.graph();
}
